var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"user-status"},[(_vm.status == 'closed')?_c('v-chip',{attrs:{"small":"","outline":"","color":"success","disabled":""}},[_vm._v("Resolvido")]):_vm._e(),_vm._v(" "),(_vm.status == 'open')?_c('v-chip',{attrs:{"small":"","outline":"","color":"red","disabled":""}},[_vm._v("Em aberto")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8bc8deb0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/support/AdminTicketStatusLabel.vue
// module id = null
// module chunks = 